export const QUICK_ORDER_SAVED_ITEMS = 'catSavedQOItems';
export const ADD_TO_CART_ITEMS = 'gaQOCookie';
export const SIS_CART_PARTS_LIST = 'sisPartsList';
export const GENERAL = 'PCC General';
export const OPTANON_ALERT_BOX_CLOSED = 'OptanonAlertBoxClosed';
